export const GET_ALL_CATEGORY_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_ALL_CATEGORY_FAILURE = "GET_CUSTOMERS_FAILURE";
export const GET_ALL_CATEGORY_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const GET_ALL_SUBCATEGORY_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_ALL_SUBCATEGORY_FAILURE = "GET_CUSTOMERS_FAILURE";
export const GET_ALL_SUBCATEGORY_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const GET_ALL_PRODUCTCATEGORY_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_ALL_PRODUCTCATEGORY_FAILURE = "GET_CUSTOMERS_FAILURE";
export const GET_ALL_PRODUCTCATEGORY_SUCCESS = "GET_CUSTOMERS_SUCCESS";